/* ==========================================================================
   custom.js — Design-Fixes nach dem Audit vom 2026-09-10
   Prüfmaßstab: Skill "apple-design".
   Wird in layout/theme.liquid als klassisches Skript VOR theme.js geladen.
   Der Grund: Ein Teil der Korrekturen muss greifen, bevor die Custom
   Elements des Themes registriert werden. Klassische Skripte laufen vor
   Modul-Skripten, theme.js ist ein Modul.
   Diese Datei fasst theme.js NICHT an. Sie korrigiert nur Verhalten zur
   Laufzeit und übersteht damit ein Theme-Update unbeschadet.
   ========================================================================== */
(function () {
  'use strict';

  function reduce() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    catch (e) { return false; }
  }

  /* ------------------------------------------------------------------
     B43 — Vorschlagssuche: 280 ms Wartezeit vor jedem Tastendruck
     §1 Response: "Audit debounces … Anything on the input path that
     isn't essential is a regression."
     Das Theme liest die Verzögerung im Konstruktor aus einem Getter.
     Deshalb wird die Klasse bei ihrer Registrierung gepatcht.
     ------------------------------------------------------------------ */
  try {
    var origDefine = customElements.define.bind(customElements);
    customElements.define = function (name, ctor, opts) {
      try {
        if (name === 'predictive-search' && ctor && ctor.prototype) {
          Object.defineProperty(ctor.prototype, 'autoCompleteDelay', {
            get: function () { return 120; },
            configurable: true
          });
        }
      } catch (e) { /* Registrierung darf nie scheitern */ }
      return origDefine(name, ctor, opts);
    };
  } catch (e) {}

  /* ------------------------------------------------------------------
     B28 — Sechs Aufrufe erzwingen weiches Scrollen ohne Prüfung
     §14: bei reduzierter Bewegung statt Bewegung ein harter Wechsel.
     ------------------------------------------------------------------ */
  try {
    function calm(args) {
      var o = args[0];
      if (o && typeof o === 'object' && o.behavior === 'smooth' && reduce()) {
        args[0] = Object.assign({}, o, { behavior: 'auto' });
      }
      return args;
    }
    ['scrollTo', 'scrollBy'].forEach(function (m) {
      var onWindow = window[m], onElement = Element.prototype[m];
      if (onWindow) {
        window[m] = function () { return onWindow.apply(this, calm([].slice.call(arguments))); };
      }
      if (onElement) {
        Element.prototype[m] = function () { return onElement.apply(this, calm([].slice.call(arguments))); };
      }
    });
    var origIntoView = Element.prototype.scrollIntoView;
    Element.prototype.scrollIntoView = function () {
      return origIntoView.apply(this, calm([].slice.call(arguments)));
    };
  } catch (e) {}

  /* ------------------------------------------------------------------
     B27 — Drawer, Sidebar, Popup, Modal und Popover schoben sich auch
     bei reduzierter Bewegung ins Bild.
     §14: "replace slides/springs/parallax with static transitions."
     Bewegende Eigenschaften werden entfernt, Deckkraft bleibt, Dauer
     wird auf 200 ms gedeckelt. Endlos-Animationen (Spinner, Laufband)
     bleiben unberührt — sie zeigen Status und stehen im CSS.
     ------------------------------------------------------------------ */
  try {
    var origAnimate = Element.prototype.animate;
    var BEWEGT = /^(transform|translate|scale|rotate|left|top|right|bottom|inset)/i;
    function entschaerfen(kf) {
      var out = {};
      for (var k in kf) { if (!BEWEGT.test(k)) out[k] = kf[k]; }
      return out;
    }
    Element.prototype.animate = function (keyframes, options) {
      try {
        var endlos = options && options.iterations === Infinity;
        if (reduce() && keyframes && !endlos) {
          keyframes = Array.isArray(keyframes) ? keyframes.map(entschaerfen) : entschaerfen(keyframes);
          if (typeof options === 'number') {
            options = Math.min(options, 200);
          } else if (options && typeof options === 'object') {
            var d = (options.duration == null) ? 200 : options.duration;
            options = Object.assign({}, options, { duration: Math.min(d, 200) });
          }
        }
      } catch (e) {}
      return origAnimate.call(this, keyframes, options);
    };
  } catch (e) {}

  /* ------------------------------------------------------------------
     B29 — Klick auf eine Produktkarte wurde verschluckt, sobald sich
     die Maus zwischen Drücken und Loslassen um 1 px bewegte.
     §10: "Add ~10px of hysteresis around the target."
     Das Theme ruft in seinem Klick-Handler preventDefault() auf. Statt
     dieses Handlers zu ändern, wird preventDefault für genau dieses
     eine Ereignis wirkungslos gemacht, wenn die Bewegung unter der
     Schwelle lag. Der Handler des Themes läuft unverändert weiter.
     ------------------------------------------------------------------ */
  try {
    var SCHWELLE = 10;
    document.addEventListener('mousedown', function (e) {
      var car = e.target.closest && e.target.closest('scroll-carousel[allow-drag]');
      if (car) { car.__startX = e.clientX; }
    }, true);
    document.addEventListener('click', function (e) {
      var car = e.target.closest && e.target.closest('scroll-carousel[allow-drag]');
      if (car && typeof car.__startX === 'number' &&
          Math.abs(e.clientX - car.__startX) <= SCHWELLE) {
        e.preventDefault = function () {};
      }
    }, true);
  } catch (e) {}

  /* ------------------------------------------------------------------
     B56 — Auf dem Weg zum Produkt wurde nichts vorgeladen, obwohl das
     Theme die Links sogar dafür markiert.
     §1 Response: "Be vigilant about every latency."
     Beim Überfahren bzw. Antippen wird die Produktseite vorgeladen, so
     dass der Klick auf den Cache trifft. Genau das macht der
     Variantenwähler des Themes bereits.
     ------------------------------------------------------------------ */
  try {
    var schonGeladen = {};
    function vorladen(url) {
      if (!url || schonGeladen[url] || url.charAt(0) !== '/') return;
      schonGeladen[url] = true;
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.as = 'document';
      l.href = url;
      document.head.appendChild(l);
    }
    function waermen(e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var link = t.closest('a[href*="/products/"]');
      if (link) { vorladen(link.getAttribute('href')); return; }
      var qa = t.closest('.product-card__quick-add-button');
      if (qa) {
        var karte = qa.closest('.product-card');
        var l2 = karte && karte.querySelector('a[href*="/products/"]');
        if (l2) vorladen(l2.getAttribute('href'));
      }
    }
    document.addEventListener('pointerover', waermen, true);
    document.addEventListener('touchstart', waermen, { capture: true, passive: true });
  } catch (e) {}

  /* ------------------------------------------------------------------
     B58 — Der leere Warenkorb war eine Sackgasse: eine Überschrift,
     ein Satz, kein Weg zurück außer dem Schließen-X.
     §16 Wayfinding: "Where can I go? … Never trap the user."
     ------------------------------------------------------------------ */
  try {
    var ZIEL = '/collections/frontpage';
    function leerenWarenkorbErgaenzen() {
      var d = document.getElementById('cart-drawer');
      if (!d || d.querySelector('.leerer-warenkorb')) return;
      if (d.querySelector('form, [slot="footer"], line-item, a[href*="/checkout"]')) return;
      var satz = d.querySelector('p.text-center');
      if (!satz) return;
      var box = document.createElement('div');
      box.className = 'leerer-warenkorb';
      var a = document.createElement('a');
      a.className = 'button';
      a.setAttribute('href', ZIEL);
      a.textContent = 'Zu den Produkten';
      var hinweis = document.createElement('p');
      hinweis.className = 'leerer-warenkorb__hinweis text-subdued';
      hinweis.textContent = 'Kostenloser Versand ab 50 €';
      box.appendChild(a);
      box.appendChild(hinweis);
      satz.insertAdjacentElement('afterend', box);
    }
    function beobachten() {
      leerenWarenkorbErgaenzen();
      var d = document.getElementById('cart-drawer');
      if (d && window.MutationObserver) {
        new MutationObserver(function () { leerenWarenkorbErgaenzen(); })
          .observe(d, { childList: true });
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', beobachten);
    } else { beobachten(); }
  } catch (e) {}

  /* ------------------------------------------------------------------
     B42 (Stufe 1) — Newsletter-Formulare zeigten beim Absenden keinen
     Status. §16 Feedback: "expose ongoing status."
     Der Ladezustand nutzt dieselbe aria-busy-Darstellung wie die
     Kaufen-Buttons (siehe custom.css, B40). Die Übermittlung selbst
     wird bewusst NICHT abgefangen, damit die Anmeldung unverändert
     über Shopify läuft.
     ------------------------------------------------------------------ */
  try {
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.matches || !f.matches('form[action*="/contact"]')) return;
      var b = f.querySelector('button[type="submit"]') || f.querySelector('button.button');
      if (b) b.setAttribute('aria-busy', 'true');
    }, true);
  } catch (e) {}
})();
